import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api from "@/lib/api";

export function DeletePipelineModal({ pipeline, onClose, confirmText, setConfirmText, onDelete }) {
  const [leads, setLeads] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setLeads(null);
    if (pipeline) api.get(`/pipelines/${pipeline.id}/resumo`).then(({ data }) => setLeads(data.leads)).catch(() => setLeads(0));
  }, [pipeline]);

  if (!pipeline) return null;
  const matches = confirmText.trim() === (pipeline.nome || "").trim();

  const confirm = async () => {
    setBusy(true);
    try { await onDelete(); } finally { setBusy(false); }
  };

  return (
    <Dialog open={!!pipeline} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-sm" data-testid="delete-pipeline-modal">
        <DialogHeader>
          <DialogTitle className="text-base font-semibold">Excluir campanha</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <p className="text-sm text-zinc-200" data-testid="delete-pipeline-question">
            Excluir a campanha <strong>"{pipeline.nome}"</strong>? Ela tem{" "}
            <strong data-testid="delete-pipeline-lead-count">{leads === null ? "..." : leads}</strong> lead{leads === 1 ? "" : "s"}.
          </p>
          <p className="text-xs text-zinc-500">
            A campanha e os leads somem de todas as telas e relatórios. Nada é apagado: o suporte SalonUP consegue restaurar.
          </p>
          <div>
            <Label className="text-xs mb-1 block">Digite <strong>{pipeline.nome}</strong> para confirmar:</Label>
            <Input data-testid="delete-confirm-input" value={confirmText} onChange={(e) => setConfirmText(e.target.value)} placeholder={pipeline.nome} className="h-8 text-xs" autoFocus />
          </div>
          <div className="flex gap-2">
            <Button data-testid="delete-cancel-btn" onClick={onClose} variant="outline" className="flex-1 h-8 text-xs">Cancelar</Button>
            <Button data-testid="delete-confirm-btn" onClick={confirm} disabled={!matches || busy || leads === null} className="flex-1 bg-red-600 hover:bg-red-500 text-white h-8 text-xs font-semibold disabled:opacity-30">
              {busy ? "Excluindo..." : "Excluir campanha"}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
